<template>

<div class="flex flex-col items-center justify-center w-full h-full bg-blue-100 mt-10 text-center">
    <!-- Check that the SDK client is not currently loading before accessing is methods -->
  
  <div v-if="showLoader" class="flex justify-center">

    <ripple-loader ></ripple-loader>
  </div>

    <div v-else class="shadow-2xl border border-blue-400 rounded-lg sticky top-0 z-10 bg-blue-100  flex flex-col lg:flex-row justify-between w-full" dir="ltr">
      
      <div class="flex flex-col justify-center items-center text-white
       lg:text-2xl text-xl text-center w-full  lg:m-5 lg:rounded-l-full rounded-t-lg"        
       :class="{'my-pink': isPinkStyle, 'my-blue': !isPinkStyle}">


        <label class="bg-blue-400 p-1 lg:p-10 lg:rounded-full text-xs rounded-lg w-1/2">{{$t('home.welcomeToPnadi')}}</label>
      </div>

      <div  class="lg:mb-10 lg:mt-5 rounded-full p-1 lg:w-1/2 justify-center content-center bg-purple-100 
      lg:rounded border-blue-800">
      
        <login :reloadAfterLogout="reloadAfterLogout"></login>
    </div>


    <!-- <div id="otEmbedContainer" style="width:800px; height:640px"></div> <script src="https://tokbox.com/embed/embed/ot-embed.js?embedId=ff10686e-3776-4a1a-9781-e3e0142ad3aa&room=DEFAULT_ROOM"></script> -->

    <!-- <script src="https://static.opentok.com/v2/js/opentok.js"></script>
      <script>

      // credentials
      var apiKey = '45828062';
      var sessionId = '1_MX40NTgyODA2Mn5-MTU4OTIzMTA2NjIyMX5yYTRXd3RDeWRjckV3UTVabVMyZnZ6Ylp-UH4';
      var token = 'T1==cGFydG5lcl9pZD00NTgyODA2MiZzaWc9YjI4YzlkMTZmNjg3MDcwMWZiOTc1YWY3YTE3MmI2ZGMxYWY2MTM5MzpzZXNzaW9uX2lkPTFfTVg0ME5UZ3lPREEyTW41LU1UVTRPVEl6TVRBMk5qSXlNWDV5WVRSWGQzUkRlV1JqY2tWM1VUVmFiVk15Wm5aNllscC1VSDQmY3JlYXRlX3RpbWU9MTU4OTIzMTA2OCZub25jZT0wLjI1ODE1Njk0NjY2NzMwNDQmcm9sZT1wdWJsaXNoZXImZXhwaXJlX3RpbWU9MTU4OTMxNzQ2OA==';

      // connect to session

      var session = OT.initSession(apiKey, sessionId);

      // create publisher
      var publisher = OT.initPublisher();
      session.connect(token, function(err) {
        // publish publisher
        
      });

      // create subscriber
      session.publish(publisher);

    session.on('streamCreated', function(event) {
      session.subscribe(event.stream);
    });
      </script> -->
      
    <div class="flex flex-col justify-center items-center text-white
       lg:text-2xl text-md text-center w-full lg:m-5 lg:rounded-r-full :rounded-b-full"
        :class="{'my-pink': isPinkStyle, 'my-blue': !isPinkStyle}">
        
        <!-- todo <label>{{$t('home.moreFeature')}}</label>
        <label>{{$t('home.areComing')}}</label> -->
        
        <label>{{$t('home.allOfYourFitnessNeeds')}}</label>
      </div>
    </div>

    <div v-if="!isDevelopmentMode" class="flex flex-wrap justify-center w-full mt-5 lg:mt-10 mb-32" style="height: 40px;">
        <!-- preview-image-size="sddefault" -->
        <lazy-youtube-video src="https://www.youtube.com/embed/DvaM07VU07U" 
        preview-image-size="sddefault"
        autoplay="false"/>
    </div>  

    <div v-else class="flex flex-wrap justify-center w-full mt-5 lg:mt-10 mb-32 " style="height: 40px;">
        <lazy-youtube-video src="https://www.youtube.com/embed/DvaM07VU07U" 
        preview-image-size="sddefault"
        :autoplay="false"/>
    </div>

      <div class="flex flex-col items-center mt-8 lg:mt-20 p-2 lg:p-5 bg-blue-300 rounded-full border-blue-800 border-4">
        <br/>
        <br/>
          <strong>{{$t('home.yourComprehensive')}}
        </strong>
        <br/>
        <br/>
        
          <a href="mailto:pnadi@pnadi.com"><label class="bg-white rounded hover:bg-pink-300 p-1 lg:p-2 text-pink-800">
             {{$t('home.email1')}} <strong>{{$t('home.email2')}}</strong></label></a>    
    </div>

    <div class="flex lg:flex-row flex-col lg:justify-around content-around">

      <div class="mt-8 lg:mt-20 p-1 lg:p-5 bg-pink-300 rounded lg:rounded-lg border-blue-800 border-4 lg:mr-2">
            <p>{{$t('home.allBuisnessesp1')}}</p>
            <br/>
           {{$t('home.allBuisnessesp2')}}
      </div>

      <div class="lg:ml-2 mt-8 lg:mt-20 p-5 bg-purple-300 rounded-lg border-blue-800 border-4">

        <p>{{$t('home.allAtheletesp1')}}</p>
        <br/>
        {{$t('home.allAtheletesp2')}}      
      </div>
    </div>

    <div v-bind:class="{'hidden': !contactDropdownPopoverShow, 'block': contactDropdownPopoverShow}" 
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mb-1" ref="popoverContactRef">
        
        <a v-if ="$countryCode == 'KW'" href="https://www.instagram.com/pnadi.app"  
        class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">

        <img src="@/assets/images/instagram-icon.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

          <!-- <span class="tab tab-explore block text-xs"><p>Instagram</p></span> -->
        </a>
        
        <a v-if ="$countryCode == 'KW'" :href="`https://wa.me/0096599003047`" 
        class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
        
            <img src="@/assets/images/whatsapp.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

            <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
        </a>

        <a  v-else :href="`https://wa.me/004407818378901`" 
        class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
        
            <img src="@/assets/images/whatsapp.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

            <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
        </a>

        <a :href="`mailto: pnadi@pnadi.com`"  
        class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
            
            <img src="@/assets/images/mail.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

            <!-- <span class="tab tab-explore block text-xs"><p>Email</p></span> -->
        </a>
        
        <div class="h-0 my-2 border border-solid border-t-0 border-gray-900 opacity-25"></div>

            <a v-if ="$countryCode == 'KW'" :href="`tel:0096599003047`" class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                <img src="@/assets/images/call-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Call</p></span> -->
            </a>

            <a v-else :href="`tel:004407818378901`" class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                <img src="@/assets/images/call-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Call</p></span> -->
            </a>
    </div>

    <div id="whatsAppIcon" ref="contactBtnDropdownRef" class="fixed flex z-10 right-0 bottom-0 opacity-100 w-10 h-12 mb-64 rounded-full me-2">
                    
      <div class="self-center opacity-100 text-MyFloatButtonsText text-xl">

          <a @click="toggleContactDropdown">
            
            <img class="object-scale-down w-8 h-8" src="@/assets/images/contact-icon.svg" alt="Contact">
          </a>
      </div>
    </div> 

    <div  class="w-full h-full p-5 lg:p-10 mb-16">

      <img src="@/assets/images/home_background.jpg" class="w-full h-full rounded lg:rounded-full"/>
    </div>
  <!-- <div>
    <my-footer class="h-10 lg:h-20" :name_1="'Reload/Refresh'" :name_2="'Instagram'" :name_3="'Reset/App'" :action_1="reLoadApp"
    :action_2="goToInstagram" :action_3="resetApp"></my-footer>
  </div> -->
</div>
</template>

<script>
// @ is an alias to /src
import Login from '../components/Login';

import componentHelpers from '../classes/componentHelpers';

import { RippleLoader } from 'vue-spinners-css';

// import myFooter from '../components/MyFooter';

import myFooter from '../components/MyFooter4';

import componentsHelpers from '../classes/componentHelpers';

import { createPopper } from '@popperjs/core';

//npm install vue-lazy-youtube-video --save
import LazyYoutubeVideo from 'vue-lazy-youtube-video'


export default {
  name: 'home',

  created(){

    // console.log(`apollo: ${this.$apollo}`);
    //   console.log(`toasted: ${this.$toasted}`);
    //   console.log(`t: ${this.$t}`);

    // console.log(`mode: ${process.env.NODE_ENV}`);

    // console.log(`dev mode: ${process.env.NODE_ENV}`)
    // console.log(`dev == development: ${process.env.NODE_ENV == 'development'}`)

    const apollo = this.$apollo;

    const toasted = this.$toasted;

    const userId = this.userId;

    const t = this.$t;

    if(localStorage.hasOwnProperty("showedBanner")){

      // console.log(`has`);
    
    }else{
      
      localStorage.setItem('showedBanner', 'true');

      // console.log(`now has`);
      // const t = this.$t;
      setTimeout(function(){

        componentsHelpers.toastIt(toasted, this.$t('home.addAppToast') , 1, 'toasted-primary', true);

      },10000);

      // setTimeout(function(){

      //   componentsHelpers.covidMsg(toasted);

      // }, 20000);

      // setTimeout(function(){

      // componentsHelpers.RamadanOffer(toasted);

      // }, 30000);
    }
  },

  async mounted(){

      if(localStorage.hasOwnProperty('businessView')){

        const businessView = localStorage.getItem('businessView');

        if(businessView == 'true'){

          const goTo = localStorage.setItem('businessLayout1', 'home');
        }else{

          const goTo = localStorage.setItem('clientLayout1', 'home');
        }
      }else{

        localStorage.setItem('businessView', 'false');
        
        localStorage.setItem('clientLayout1', 'home');

        this.$layoutType = 0;
      }

      const toast = this.$toasted;

    this.showLoader = true;

   // console.log(`Created, inside Home component and redirected is ${this.$route.query.redirected}`);

    if(this.$route.query.redirected === 'true')
        {

          this.$router.replace({'query': null});
        
          console.log(`Created, inside app.vue component and redirected`);
          
          // this.$forceUpdate();

          await this.reloadWebsite();
        }

      this.showLoader = false;

  },

  components: {

    Login,
    myFooter,
    LazyYoutubeVideo
    
  },

  methods: {

    toggleContactDropdown(){

      // console.log(`inside toggleContactDropdown`);
        
        const test = new createPopper();

        if(this.contactDropdownPopoverShow){

                // console.log(`inside if`);

            this.contactDropdownPopoverShow = false;
        } else {
                          // console.log(`inside else`);

            this.contactDropdownPopoverShow = true;
            new createPopper(this.$refs.contactBtnDropdownRef, this.$refs.popoverContactRef, {
            placement: "top"
            });
        }
      },

    reLoadApp(){

      location.reload(true);
    },

    resetApp(){

      localStorage.clear();

      location.reload(true);
    },

      changeLanguage(){

      componentsHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);
    },

    // goToInstagram(){

    //       // For now go Home
    //       this.$router.replace({ path: '/home', query: { redirected: 'false' }});
    // },

    
    async reloadWebsite(){

    await this.sleep(2000);

    while(localStorage.getItem('for_pnadi') === ''){
          
          // console.log('******** Email exists');

          await this.sleep(3000);
    }
    // console.log(`******** Email exists with ${localStorage.getItem('email')}`);
          await this.sleep(1000);

    this.showLoader = false;
    location.reload();
    },

    async reloadAfterLogout(){

    this.showLoader = true;
    await this.sleep(2000);
    while(localStorage.getItem('for_pnadi') !== ''){
          
          await this.sleep(1000);
    }
    this.showLoader = false;
    location.reload();
    },

    async sleep(ms){
       
        this.count = this.count + 1;
        return await new Promise(resolve => setTimeout(resolve, ms));
      },
  },
  
  data:function (){

    return{

      showLoader: false,
      isPinkStyle: true,
      contactDropdownPopoverShow: false,
      isDevelopmentMode: process.env.NODE_ENV == 'development'
      // businessView: false,
    }
  },

  watch: {
        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;

            // console.log(`in Watcehr: pink is ${newValue}`);
            }
        }
};
</script>
